// extracted by mini-css-extract-plugin
export var bannerBody = "BookingButton-module--banner-body--c0d68";
export var bannerTitle = "BookingButton-module--banner-title--6f59a";
export var bookingBanner = "BookingButton-module--booking-banner--0d093";
export var desktopImage = "BookingButton-module--desktopImage--8e846";
export var illustration = "BookingButton-module--illustration--044b6";
export var mobileImage = "BookingButton-module--mobileImage--f9cc1";
export var redButton = "BookingButton-module--redButton--05656";
export var root = "BookingButton-module--root--f7338";
export var smallRedButton = "BookingButton-module--small-red-button--acd94";
export var symbol = "BookingButton-module--symbol--115d2";